/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:16/01/2021
 @Time:08:03
 **/



import Produit from "./Produit";
import TranslationService from "../../../i18n/service/TranslationService";
import LangueService from "../../../i18n/service/LangueService";

export default class ProduitPaquet {


    /**
     * @type{String}
     */
    #_produitID=null;
    /**
     * @type{string}
     */
    #id;
    /**
     * @type {number}
     */
    #quantite = 0;

    /**
     * @type{Produit}
     */
    #produit = null;

    /**
     *
     * @type {Object<String,String>}
     */
    #_designation = {};


    constructor(id, quantite) {
        this.#id = id;
        this.#quantite = quantite;
    }

    set quantite(quantite) {
        this.#quantite = quantite;
        return this;
    }

    get quantite() {
        return this.#quantite;
    }

    set id(id) {
        this.#id = id;
        return this;
    }

    get id() {
        return this.#id;
    }


    get produitID() {
        return this.#produit!=null?this.#produit.id:this.#_produitID;
    }

    set produitID(value) {
        this.#_produitID =  value;
    }

    /**
     * set le produit attaché au paquet
     * @param {Produit} produit
     */
    set produit(produit) {
        this.#produit = produit;
        let langues=LangueService.getInstance().langues;
        for (let index in langues) {
            let locale = langues[index].locale;
            this.addDesignation(ProduitPaquet.generateProduitPaquetDesignation(this.#produit.getDesignation(locale), this.quantite), locale);
        }
    }

    /**
     *
     * @return {Produit}
     */
    get produit() {
        return this.#produit;
    }


    /**
     * Ajoute une traduction pour la designation d'un produit paquet
     * @param {String} designation
     * @param {String} locale
     */
    addDesignation(designation, locale) {
        Begro.logInfo("Ajout de produit paquet designation "+designation+" locale "+locale+" id produit "+this.id);
        this.#_designation[locale] = designation;
    }

    /**
     * retourne la designation du produit paquet dans une locale passé en paramètre
     * @param locale
     * @return {string}
     */
    getDesignation(locale) {
        if (this.#_designation[locale] !== undefined) {
            return this.#_designation[locale];
        } else {
               Begro.logInfo("objet produit not définit pour le produit paquet " + this.#id);
               return "";
        }
    }

    /**
     * retourne la liste des étiquettes associées a un produit
     * @return {*}
     */
    getEtiquettes() {
        return (this.#produit!=null)?this.#produit.getEtiquettes():{};
    }

    /**
     * méthode qui retourne une instance du produit paquet si existe dans la propriété de classe Begro sinon on le crée
     * et on l'ajoute a begro
     * @param produitPaquetJson
     * @returns {ProduitPaquet}
     */
    static createProduitPaquetFromJson(produitPaquetJson) {
        let activeLocale=LangueService.getInstance().activeLangue.locale;
        let produitPaquet = Begro.getProduitPaquetById(produitPaquetJson.id);
        if (!produitPaquet) {
            Begro.env !== "dev" || console.log("======Début création nouvelle instance du produit Paquet " + produitPaquetJson.id + " ======");
            produitPaquet = new ProduitPaquet(produitPaquetJson.id, produitPaquetJson.quantite);
            produitPaquet.produitID=produitPaquetJson.produitID;
            if(typeof produitPaquetJson.produit ==='undefined'|| produitPaquetJson.produit === null)
            {
                Produit.getById(produitPaquetJson.produitID,function(produit){
                    produitPaquet.produit=produit;
                });
            }
            Begro.addProduitPaquetList(produitPaquet);
            Begro.env !== "dev" || (console.log("======Fin création nouvelle instance du produit Paquet " + produitPaquet.id + " ======") && console.log("==>Le produit paquet " + produitPaquet.id + " est ajouté au conteneur Globale Begro"));
        } else {
            Begro.env !== "dev" || console.log("==>Le produit " + produitPaquet.getDesignation(activeLocale) + " - " + produitPaquet.id + " est retiré depuis le conteneur globale Begro");
        }
        return produitPaquet;
    }

    /**
     * Générer le designation d'un produit paquet
     * @param {String} designation
     * @param {number} quantite
     */
    static generateProduitPaquetDesignation(designation, quantite) {
        return TranslationService.getInstance().translate("produit:paquet.designation",{produitDesignation:designation,quantite:quantite}) ;
    }

}